import { t } from "i18next";

export const UserListColumn = [
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:USER_ID_FIELD")}
            </span>
        ),
        dataIndex: 'userId',
        key: 'userId',
        sorter: {
            compare: (a, b) => a.userId.localeCompare(b.userId)
        },
        render: (userId) => <span>{userId}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:USERNAME_FIELD")}
            </span>
        ),
        dataIndex: 'username',
        key: 'username',
        sorter: {
            compare: (a, b) => a.username.localeCompare(b.username)
        },
        render: (username) => <span>{username}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:EMAIL_FIELD")}
            </span>
        ),
        dataIndex: 'email',
        key: 'email',
        render: (email) => <span>{email}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:FIRST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'firstName',
        key: 'firstName',
        render: (firstName) => <span>{firstName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:LAST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'lastName',
        key: 'lastName',
        render: (lastName) => <span>{lastName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:MOBILE_PHONE_FIELD")}
            </span>
        ),
        dataIndex: 'mobilePhone',
        key: 'mobilePhone',
        render: (mobilePhone) => <span>{mobilePhone}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:ACTION_FIELD")}
            </span>
        ),
        dataIndex: 'action',
        key: 'action',
        render: (action) => (action),
    },
]

export const UserInvitationListColumn = [
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER_INVITATION:EMAIL_FIELD")}
            </span>
        ),
        dataIndex: 'email',
        key: 'email',
        render: (email) => <span>{email}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER_INVITATION:DATA_GROUP_FIELD")}
            </span>
        ),
        dataIndex: 'dataGroup',
        key: 'dataGroup',
        render: (dataGroup) => <span>{dataGroup}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER_INVITATION:ROLE_FIELD")}
            </span>
        ),
        dataIndex: 'role',
        key: 'role',
        render: (role) => <span>{role}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER_INVITATION:STATUS_FIELD")}
            </span>
        ),
        dataIndex: 'status',
        key: 'status',
        render: (status) => <span>{status}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER_INVITATION:ACTION_FIELD")}
            </span>
        ),
        dataIndex: 'action',
        key: 'action',
        render: (action) => <span>{action}</span>,
    },
]

export const CustomerListColumn = [
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Customer Id")}
            </span>
        ),
        dataIndex: 'customerId',
        key: 'customerId',
        sorter: {
            compare: (a, b) => a.customerId.localeCompare(b.customerId)
        },
        render: (customerId) => <span>{customerId}</span>,
    },
    
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:FIRST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'firstName',
        key: 'firstName',
        render: (firstName) => <span>{firstName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:LAST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'lastName',
        key: 'lastName',
        render: (lastName) => <span>{lastName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Phone")}
            </span>
        ),
        dataIndex: 'mobilePhone',
        key: 'mobilePhone',
        render: (mobilePhone) => <span>{mobilePhone}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Fax")}
            </span>
        ),
        dataIndex: 'fax',
        key: 'fax',
        render: (fax) => <span>{fax}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:EMAIL_FIELD")}
            </span>
        ),
        dataIndex: 'email',
        key: 'email',
        render: (email) => <span>{email}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:ACTION_FIELD")}
            </span>
        ),
        dataIndex: 'action',
        key: 'action',
        render: (action) => (action),
    },
]

export const DriverListColumn = [
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Driver Photo")}
            </span>
        ),
        dataIndex: 'photo',
        key: 'photo',
        render: (photo) => <span>{photo}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Driver Id")}
            </span>
        ),
        dataIndex: 'driverId',
        key: 'driverId',
        sorter: {
            compare: (a, b) => a.driverId.localeCompare(b.driverId)
        },
        render: (driverId) => <span>{driverId}</span>,
    },
    
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:FIRST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'firstName',
        key: 'firstName',
        render: (firstName) => <span>{firstName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:LAST_NAME_FIELD")}
            </span>
        ),
        dataIndex: 'lastName',
        key: 'lastName',
        render: (lastName) => <span>{lastName}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Vehicle ID")}
            </span>
        ),
        dataIndex: 'vehicleId',
        key: 'vehicleId',
        render: (vehicleId) => <span>{vehicleId}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Phone")}
            </span>
        ),
        dataIndex: 'phone',
        key: 'phone',
        render: (phone) => <span>{phone}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("Status")}
            </span>
        ),
        dataIndex: 'status',
        key: 'status',
        render: (status) => <span>{status}</span>,
    },
    {
        title: (
            <span className="font-roboto text-lg text-[#222222]">
                {t("USER:ACTION_FIELD")}
            </span>
        ),
        dataIndex: 'action',
        key: 'action',
        render: (action) => (action),
    },
]